import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import instance from "../../../../../axios/instance"
import { generateInstantChannel } from "../dashboard/page"

export default function InstantSetUp() {

    const [user, setUser] = useState("")
    const [error, setError] = useState("")
    const location = useLocation()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const meetingId = location.pathname.split("instant/")[1]

    // get doctor info

    async function getDoctorInfo() {
        setLoading(true)
        instance.post("/doctor/single", {
            doctorId: meetingId
        })
        .then(doc_response => {
            console.log(doc_response.data);
            const doctor = `${doc_response.data.prefix}. ${doc_response.data.firstname} ${doc_response.data.lastname}`
            const doctor_id = doc_response.data.id

            joinMeeting(doctor, doctor_id)
        })
        .catch(error => {
            console.log(error.response.data);
            
        })
    }

    function joinMeeting(doctor, doctor_id) {
        setError("")
        if (!user) {
            setError("Input field can not be empty")
            setLoading(false)
        } else {
            
            const channelName = generateInstantChannel(meetingId)

            instance.post("/telemedicine/agora/token", {
                uid: user,
                channelName: channelName
            })
            .then(response => {
                console.log(response.data);
                console.log(channelName);
                
                navigate("/telemedicine/meeting/instant", { state: {
                    user: user,
                    channelName: channelName,
                    token: response.data.token,
                    doctor: doctor,
                    doctor_id: doctor_id
                } })
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response.data);
                setError(error.response.data.message)
                setLoading(false)
            })
        }
    }

    return (
        <div className="h-[100svh] flex justify-center items-center">

            <div className="space-y-4">
                <div className="font-semibold text-[24px]">You've been invited to join a meeting</div>

                <div className="flex flex-col w-[400px] gap-3">
                    <input onChange={e => setUser(e.target.value)} placeholder="Enter your name" className="p-3 bg-[#f1f1f1] rounded-[6px] outline-none" />
                    <button onClick={getDoctorInfo} disabled={loading} className={`${loading ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} rounded-[6px] p-3 font-semibold text-white`}>Join Meeting</button>
                </div>

                <div className="text-red-500 text-[14px] font-semibold">{error}</div>
            </div>
        </div>
    )
}